import React, { useState } from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;

const DataList = ({ data, handleSort, getAllinvitedData }) => {
  const [expandedKeys, setExpandedKeys] = useState(new Set());

  const toggleExpand = (key) => {
    setExpandedKeys((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  };

  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th className="w-12"></Th>
              <Th>Provider ID</Th>
              <Th onClick={(e) => handleSort(e, "provider_trading_name")}>
                <span className="flex items-center gap-1">
                  Provider
                  {getAllinvitedData.sort === "provider_trading_name" && (
                    <svg
                      className={`transform ${
                        getAllinvitedData.order === "asc" ? "rotate-180" : ""
                      }`}
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                        stroke="#475467"
                        strokeWidth="1.333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </span>
              </Th>
              <Th className="text-center">Total Workers</Th>
              <Th className="text-center">Total Documents</Th>
            </Tr>
          </THead>
          <TBody>
            {data?.DocsReport?.length > 0 &&
              data.DocsReport.map((group, index) => {
                const providerKey = group.provider_org_id || group.provider_trading_name;
                const isExpanded = expandedKeys.has(providerKey);

                // Group the documents by worker_id (safer than name alone)
                const workerGroups = {};
                if (group.documents) {
                  group.documents.forEach((item) => {
                    const workerKey = item.worker_id || item.worker_name || "Unknown";
                    if (!workerGroups[workerKey]) {
                      workerGroups[workerKey] = {
                        workerName: item.worker_name || "Unknown Worker",
                        workerDisplayId: item.worker_display_id || (item.worker_id ? `E-${item.worker_id}` : "-"),
                        docs: [],
                      };
                    }
                    workerGroups[workerKey].docs.push(item);
                  });
                }

                return (
                  <React.Fragment key={index}>
                    <Tr
                      className="text-gray-800 hover:bg-gray-50 transition-colors cursor-pointer"
                      onClick={() => toggleExpand(providerKey)}
                    >
                      <Td className="w-12 text-center">
                        <button
                          type="button"
                          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 transition-colors"
                          aria-label="Expand row"
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={`transform transition-transform duration-200 ${
                              isExpanded ? "rotate-180" : ""
                            }`}
                            aria-hidden="true"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="#475467"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </Td>
                      <Td className="text-gray-500 text-sm">
                        {group.provider_org_id || "-"}
                      </Td>
                      <Td className="font-semibold text-gray-700">
                        {group.provider_trading_name || "Unknown Provider"}
                      </Td>
                      <Td className="text-center font-medium">
                        {group.total_workers || 0}
                      </Td>
                      <Td className="text-center font-medium">
                        {group.total_documents || 0}
                      </Td>
                    </Tr>
                    {isExpanded && (
                      <Tr>
                        <Td colSpan={5} className="bg-gray-50/50 p-4">
                          <div className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm ml-4 mr-4 mb-2">
                            <Table className="min-w-full text-sm">
                              <THead>
                                <Tr>
                                  <Th className="bg-gray-50/80 font-semibold py-2">
                                    Worker ID
                                  </Th>
                                  <Th className="bg-gray-50/80 font-semibold py-2">
                                    Worker
                                  </Th>
                                  <Th className="bg-gray-50/80 font-semibold py-2">
                                    Documents name
                                  </Th>
                                  <Th className="bg-gray-50/80 font-semibold py-2">
                                    Status
                                  </Th>
                                  <Th className="bg-gray-50/80 font-semibold py-2">
                                    Approval date
                                  </Th>
                                  <Th className="bg-gray-50/80 font-semibold py-2">
                                    Expiry date
                                  </Th>
                                </Tr>
                              </THead>
                              <TBody>
                                {Object.entries(workerGroups)
                                  .sort((a, b) =>
                                    a[1].workerName.localeCompare(b[1].workerName)
                                  )
                                  .map(([workerKey, { workerName, workerDisplayId, docs }]) => {
                                    return docs.map((item, idx) => (
                                      <Tr
                                        key={`${workerKey}-${idx}`}
                                        className="hover:bg-gray-50/30"
                                      >
                                        {idx === 0 && (
                                          <Td
                                            rowSpan={docs.length}
                                            className="py-2.5 text-sm text-blue-700 align-top border-r border-gray-100"
                                            style={{ verticalAlign: "top" }}
                                          >
                                            {workerDisplayId}
                                          </Td>
                                        )}
                                        {idx === 0 && (
                                          <Td
                                            rowSpan={docs.length}
                                            className="py-2.5 font-medium align-top border-r border-gray-100"
                                            style={{ verticalAlign: "top" }}
                                          >
                                            {workerName}
                                          </Td>
                                        )}
                                        <Td className="py-2.5">
                                          {item?.document_name || "-"}
                                        </Td>
                                        <Td className="py-2.5">
                                          <span
                                            className={
                                              item?.status === "Approved"
                                                ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                                                : item?.status === "Action required" ||
                                                  item?.status === "\tAction required"
                                                ? "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                                                : item?.status === "Awaiting review"
                                                ? "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal"
                                                : "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                                            }
                                          >
                                            {item?.status}
                                          </span>
                                        </Td>
                                        <Td className="py-2.5">
                                          {item?.approval_date
                                            ? moment(item?.approval_date).format(
                                                "DD/MM/YYYY"
                                              )
                                            : "-"}
                                        </Td>
                                        <Td className="py-2.5">
                                          {item?.expiry_date
                                            ? moment(item?.expiry_date).format(
                                                "DD/MM/YYYY"
                                              )
                                            : "-"}
                                        </Td>
                                      </Tr>
                                    ));
                                  })}
                              </TBody>
                            </Table>
                          </div>
                        </Td>
                      </Tr>
                    )}
                  </React.Fragment>
                );
              })}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};

export default DataList;
